import { useEffect, useState } from 'react';
import CarouselNav from '../carousel/CarouselNav';

const LabProductCarousel = ({ images, title }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [images]);

  if (!images?.length) {
    return null;
  }

  const hasMultiple = images.length > 1;
  const activeImage = images[activeIndex];

  const showPrevious = () => {
    setActiveIndex((index) => (index - 1 + images.length) % images.length);
  };

  const showNext = () => {
    setActiveIndex((index) => (index + 1) % images.length);
  };

  return (
    <div className="lab-preview-modal__carousel">
      <div className="lab-preview-modal__carousel-frame">
        {hasMultiple && (
          <CarouselNav
            variant="solid"
            onPrevious={showPrevious}
            onNext={showNext}
            previousLabel="Previous image"
            nextLabel="Next image"
          />
        )}

        <img
          src={activeImage.src}
          alt={activeImage.alt ?? title}
          loading="eager"
          decoding="async"
        />
      </div>

      {hasMultiple && (
        <div className="lab-preview-modal__carousel-controls">
          <div className="lab-preview-modal__carousel-dots">
            {images.map((image, index) => (
              <button
                key={image.src}
                type="button"
                className={
                  index === activeIndex
                    ? 'lab-preview-modal__carousel-dot lab-preview-modal__carousel-dot--active'
                    : 'lab-preview-modal__carousel-dot'
                }
                aria-label={`Show image ${index + 1} of ${images.length}`}
                aria-current={index === activeIndex ? 'true' : undefined}
                onClick={() => setActiveIndex(index)}
              />
            ))}
          </div>
          <span className="lab-preview-modal__carousel-count">
            {activeIndex + 1} / {images.length}
          </span>
        </div>
      )}
    </div>
  );
};

export default LabProductCarousel;
